<template>
  <b-sidebar id="main-sidebar" :title="title" backdrop>
    <template>
      <Profile />
    </template>

    <hr />
    <b-nav vertical class="py-1 px-1">
      <div v-for="(value, name) in treeSidebar" :key="name">
        <strong class="sidebar-header">{{ name }}</strong>
        <div v-for="(route, index) in value" :key="index">
          <RouteCard :route="route" />
        </div>
        <hr />
      </div>
      <div v-if="isFakeAuth">
        <RouteCard :route="routeExit" />
        <hr />
      </div>
      <div class="mt-1">
        <RouteCard
          :route="routePublicationOffice"
          :popoverHelp="routePublicationOffice.popoverHelp"
        />
      </div>
      <div class="mt-1">
        <RouteCard
          :route="routeSupport"
          :popoverHelp="routeSupport.popoverHelp"
        />
      </div>
    </b-nav>
  </b-sidebar>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import Profile from '@/components/pages/home/components/sidebar/components/Profile.vue'
import { routes } from '@/router'
import { RouteConfig, RouteConfigSingleView } from 'vue-router/types/router'
import { userMappers } from '@/store/modules/user'
import { PermissionPageManager } from '@/api/permissions/pages'
import { permissions } from '@/api/permissions/permissions'
import { publicationOfficeEmail, supportEmail, wikiPage } from '@/config/urls'
import RouteCard from '@/components/pages/home/components/sidebar/components/RouteCard.vue'
import Config from '@/config/default/config'
import FakeUserAPI from '@/components/routes/dev/fake-auth/helpers/requests'
const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapGetters(['isFakeAuth'])
  }
})

@Component({ components: { RouteCard, Profile } })
export default class Sidebar extends Mappers {
  private treeSidebar: { [k: string]: RouteConfigSingleView[] } = {}
  private title = Config.systemTitle.shortName

  private routeSupport = {
    meta: {
      sidebar: {
        icon: ['fas', 'envelope']
      },
      navbar: {
        displayName: `<div>Тех. поддержка: <a href="mailto:${supportEmail}" target="_blank">${supportEmail}</a><div><a href="${wikiPage(
          'supportrules'
        )}">Правила написания</a></div></div>`
      }
    },
    popoverHelp: {
      id: 'targetSupport',
      title: 'Техническая поддержка',
      text: `По техническим вопросам, ошибкам пишите на почту ${supportEmail}`
    }
  }

  private routePublicationOffice = {
    meta: {
      sidebar: {
        icon: ['fas', 'print']
      },
      navbar: {
        displayName: `<div>Публикационный офис: <a href="mailto:${publicationOfficeEmail}" target="_blank">${publicationOfficeEmail}</a></div><div></div>`
      }
    },
    popoverHelp: {
      id: 'targetOffice',
      title: 'Публикационный офис',
      text: `По вопросам статуса заявок и публикациям пишите на почту ${publicationOfficeEmail}`,
      style: 'width: 180px;'
    }
  }

  private routeExit = {
    click: this.onLogout,
    meta: {
      sidebar: {
        icon: ['fas', 'sign-out-alt']
      },
      navbar: {
        displayName: 'Выйти из режима просмотра'
      }
    }
  }

  private created() {
    const routerPages: RouteConfig[] | undefined = routes[0].children
    const abilities = PermissionPageManager.pages()
    this.treeSidebar = {}
    if (routerPages) {
      for (const route of routerPages) {
        if (
          abilities.can(permissions.viewPage, route.name) &&
          route?.meta?.sidebar?.isDisplay
        ) {
          const group = route.meta.navbar.group
          if (group in this.treeSidebar) {
            this.treeSidebar[group].push(route)
          } else {
            this.treeSidebar[group] = [route]
          }
        }
      }
    }
  }

  private onLogout() {
    FakeUserAPI.fakeUserLogout()
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.sidebar-header {
  padding: 0 1rem;
}
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
